import setup from "../../Containers/setup";
import Type from "../Type";


const initSearchState = {
    listDistrict: [],
    districtSelected: { key: setup.huyenId },
    districtSelectedSearch: { key: setup.huyenId },
    listWard: [],
    wardSelected: '',
    wardSelectedSearch: '',
    showErrorWard: false,
    modeSearch: 'byName',
    searchText: "",
    markerPosition: null,
    pickMapOn: false, // trạng thái xác định bật chế độ chọn điểm trên gg map
    listResult: [],
    loadingSearch: false,

    loadingLoginEnter: false

}

const Search = (state = initSearchState, { type, route, value }) => {
    if (type === Type.SET_SEARCH) {
        return {
            ...state,
            [route]: value
        }
    }
    return state;
};

export default Search
